import { render, staticRenderFns } from "./PatientConsultationInfo.vue?vue&type=template&id=6ec71e8f&"
import script from "./PatientConsultationInfo.vue?vue&type=script&lang=js&"
export * from "./PatientConsultationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports